import { Typography } from '@mui/material'
import parseHtml from 'html-react-parser'
import QrCode2Icon from '@mui/icons-material/QrCode2'

import StyledPaper from '/components/paper'
import { ApplePreviewImage } from '/components/templates/apple-preview-mask.jsx'

const templatePreviewImageUrl = (template, platform = "apple") => {
  const folder = platform === "google" ? "template_previews_google" : "template_previews"
  const cacheBuster = template?.last_modified_timestamp ?? template?.last_modified ?? ""
  const ownerClientId = template?.client_id ?? 0
  return `https://s3.eu-west-1.amazonaws.com/images.smartix.uk/${ownerClientId}/${folder}/${template.template_id}.png${cacheBuster ? `?v=${cacheBuster}` : ""}`
}

const Templates = ({ templates, tabIndex, selectedTemplate, setSelectedTemplate }) => {

  if (tabIndex === "custom") return CustomTemplates({ templates, selectedTemplate, setSelectedTemplate })
  if (tabIndex === "managed") return ManagedTemplates({ templates, selectedTemplate, setSelectedTemplate })
  if (tabIndex === "specialist") return SpecialistTemplates({ templates, selectedTemplate, setSelectedTemplate })
  if (tabIndex === "examples") return ExampleTemplates({ templates, selectedTemplate, setSelectedTemplate })
}

export default Templates

const CustomTemplates = ({ templates, selectedTemplate, setSelectedTemplate }) => {

  const tps = templates.filter(t => t.managed_pass_template === 0 && t.specialist_template === 0 && !/Example/.test(t.name)).map(t => {

    const classes = selectedTemplate === t.template_id ? "selectable selected " : "selectable "

    return (
      <div key={t.template_id} onClick={() => setSelectedTemplate(t)} className='pointer'>
        <StyledPaper classes={classes}>
          <div className='flex-col justify-around' style={{ height: 650, width: 300 }}>
            <div className='h-[60px]'><Typography variant='h6'>{t.name}</Typography></div>
            <ApplePreviewImage template={t} src={templatePreviewImageUrl(t, "apple")} alt={`${t.name} Apple preview`} className='mt-5 mb-5' />
            <p>{parseHtml(t.description)}</p>
          </div>
        </StyledPaper>
      </div>
    )
  })

  return tps
}

const ManagedTemplates = ({ templates, selectedTemplate, setSelectedTemplate }) => {

  const tps = templates.filter(t => t.managed_pass_template === 1 && !/Example/.test(t.name)).map(t => {

    const classes = selectedTemplate === t.template_id ? "selectable selected " : "selectable "

    return (
      <div key={t.template_id} onClick={() => setSelectedTemplate(t)} className='pointer'>
        <StyledPaper classes={classes}>
          <div className='flex-col justify-around' style={{ height: 650, width: 300 }}>
            <div className='h-[60px]'><Typography variant='h6'><QrCode2Icon/> {t.name}</Typography></div>
            <ApplePreviewImage template={t} src={templatePreviewImageUrl(t, "apple")} alt={`${t.name} Apple preview`} className='mt-5 mb-5' />
            <p>{parseHtml(t.description)}</p>
          </div>
        </StyledPaper>
      </div>
    )
  })

  return tps
}

const SpecialistTemplates = ({ templates, selectedTemplate, setSelectedTemplate }) => {

  const tps = templates.filter(t => t.specialist_template === 1 && !/Example/.test(t.name)).map(t => {

    const classes = selectedTemplate === t.template_id ? "selectable selected " : "selectable "

    return (
      <div key={t.template_id} onClick={() => setSelectedTemplate(t)} className='pointer'>
        <StyledPaper classes={classes}>
          <div className='flex-col justify-around' style={{ height: 650, width: 300 }}>
            <div className='h-[60px]'><Typography variant='h6'>{t.name}</Typography></div>
            <ApplePreviewImage template={t} src={templatePreviewImageUrl(t, "apple")} alt={`${t.name} Apple preview`} className='mt-5 mb-5' />
            <p>{parseHtml(t.description)}</p>
          </div>
        </StyledPaper>
      </div>
    )
  })

  return tps
}


const ExampleTemplates = ({ templates, selectedTemplate, setSelectedTemplate }) => {

  const tps = templates.filter(t => t.specialist_template === 0 && /Example/.test(t.name)).map(t => {

    const classes = selectedTemplate === t.template_id ? "selectable selected " : "selectable "

    return (
      <div key={t.template_id} onClick={() => setSelectedTemplate(t)} className='pointer'>
        <StyledPaper classes={classes}>
          <div className='flex-col justify-around' style={{ height: 650, width: 300 }}>
            <div className='h-[60px]'><Typography variant='h6'>{t.managed_pass_template ? <QrCode2Icon/> : ''} {t.name}</Typography></div>
            <ApplePreviewImage template={t} src={templatePreviewImageUrl(t, "apple")} alt={`${t.name} Apple preview`} className='mt-5 mb-5' />
            <p>{parseHtml(t.description)}</p>
          </div>
        </StyledPaper>
      </div>
    )
  })

  return tps
}
